import { ProductType, PromotionTabsType } from '../../components/Layout/Promotions/PromotionsList/types';
import { RootState } from '../store';

export const productTabName = (state: RootState): ProductType | string => state.promotions?.productTabName;
export const promotionTabName = (state: RootState): PromotionTabsType => state.promotions?.promotionTab;
